import React from 'react';
import { Container, Row, Col, Badge, Table, ProgressBar, Card } from 'react-bootstrap';
import Button from '../../components/common/Button';

const EmailMarketingPage: React.FC = () => {
  const campaigns = [
    { id: 1, name: 'Welcome Series', status: 'active', sent: 12000, open: 42, click: 8 },
    { id: 2, name: 'Weekly Newsletter', status: 'active', sent: 8500, open: 38, click: 6 },
    { id: 3, name: 'Promo Blast', status: 'paused', sent: 0, open: 0, click: 0 },
  ];

  return (
    <Container fluid className="marketing-dashboard email-marketing">
      {/* Başlık Bölümü */}
      <div className="page-header">
        <div className="header-content">
          <div className="header-info">
            <div className="header-icon">
              <i className="bi bi-envelope-fill"></i>
            </div>
            <div className="header-text">
              <h1 className="page-title">Email Marketing</h1>
              <p className="page-subtitle">
                Manage your email campaigns and track performance metrics
              </p>
            </div>
          </div>
          <div className="header-actions">
            <Button
              variant="primary"
              leftIcon={<i className="bi bi-plus-lg"></i>}
              style={{ color: '#fff' }}
            >
              Create Campaign
            </Button>
          </div>
        </div>
      </div>

      <Row className="g-4">
        <Col lg={4}>
          <Card className="content-card overview-card h-100">
            <Card.Body className="card-body-custom">
              <h5 className="fw-bold mb-4" style={{ color: "var(--text-primary)" }}>Overview</h5>
              <div className="stat-row">
                <div className="d-flex justify-content-between mb-2">
                  <span className="stat-label">Open Rate</span>
                  <span className="stat-value">39%</span>
                </div>
                <ProgressBar now={39} variant="success" style={{ height: 8, borderRadius: 4 }} />
              </div>
              <div className="stat-row mt-4">
                <div className="d-flex justify-content-between mb-2">
                  <span className="stat-label">Click Rate</span>
                  <span className="stat-value">7%</span>
                </div>
                <ProgressBar now={7} variant="info" style={{ height: 8, borderRadius: 4 }} />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={8}>
          <Card className="content-card">
            <Card.Body className="p-0">
              <div className="card-header-custom p-4">
                <h5 className="section-title mb-0">Campaigns</h5>
              </div>
              <Table responsive className="campaigns-table mb-0">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Sent</th>
                    <th>Open%</th>
                    <th>Click%</th>
                    <th style={{ width: 120 }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {campaigns.map(c => (
                    <tr key={c.id}>
                      <td className="fw-medium">{c.name}</td>
                      <td>
                        <Badge bg={c.status === 'active' ? 'success' : 'secondary'} pill>
                          {c.status}
                        </Badge>
                      </td>
                      <td>{c.sent.toLocaleString()}</td>
                      <td>{c.open}%</td>
                      <td>{c.click}%</td>
                      <td>
                        <div className="d-flex gap-2">
                          <Button variant="ghost" size="sm" iconOnly style={{ color: 'var(--text-secondary)' }}>
                            <i className="bi bi-eye"></i>
                          </Button>
                          <Button variant="ghost" size="sm" iconOnly style={{ color: 'var(--text-secondary)' }}>
                            <i className="bi bi-pencil"></i>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EmailMarketingPage;